import {unRestangularize} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {Loan, Valuable} from 'typings/portaro.be.types';
import type {Pageable} from 'typings/portaro.fe.types';

export default class ReaderLoanDataService {
    public static readonly serviceName = 'readerLoanDataService';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    public async getAllLoans(userId: number, pageable?: Pageable): Promise<Loan[]> {
        return this.getLoans(userId, pageable, 'loan');
    }

    public async getAllWaitingLoans(userId: number, pageable?: Pageable): Promise<Loan[]> {
        return this.getLoans(userId, pageable, 'waiting-loan');
    }

    public async getAllEndedLoans(userId: number, pageable?: Pageable): Promise<Loan[]> {
        return this.getLoans(userId, pageable, 'ended-loan');
    }

    public async getAllMvsLoans(userId: number, pageable?: Pageable): Promise<Loan[]> {
        return this.getLoans(userId, pageable, 'mvs-loan');
    }

    public async getAllLibraryActiveMvsLoans(userId: number, pageable?: Pageable): Promise<Loan[]> {
        return this.getLoans(userId, pageable, 'library-active-mvs-loan');
    }

    public async getAllLibraryPassiveMvsLoans(userId: number, pageable?: Pageable): Promise<Loan[]> {
        return this.getLoans(userId, pageable, 'library-passive-mvs-loan');
    }

    public async getAllLoansSize(userId: number): Promise<Valuable<number>> {
        return this.getLoanSize(userId, 'loan');
    }

    public async getAllWaitingLoansSize(userId: number): Promise<Valuable<number>> {
        return this.getLoanSize(userId, 'waiting-loan');
    }

    public async getAllEndedLoansSize(userId: number): Promise<Valuable<number>> {
        return this.getLoanSize(userId, 'ended-loan');
    }

    public async getAllMvsLoansSize(userId: number): Promise<Valuable<number>> {
        return this.getLoanSize(userId, 'mvs-loan');
    }

    public async getAllLibraryActiveMvsLoansSize(userId: number): Promise<Valuable<number>> {
        return this.getLoanSize(userId, 'library-active-mvs-loan');
    }

    public async getAllLibraryPassiveMvsLoansSize(userId: number): Promise<Valuable<number>> {
        return this.getLoanSize(userId, 'library-passive-mvs-loan');
    }

    @ngAsync()
    @unRestangularize()
    private async getLoans(userId: number, pageable: Pageable, type: string): Promise<Loan[]> {
        let queryParams = {user: userId, types: type};
        queryParams = pageable ? Object.assign({}, queryParams, pageable) : queryParams;
        return this.Restangular
                   .one('loan-items')
                   .get(queryParams);
    }

    @ngAsync()
    @unRestangularize()
    private async getLoanSize(userId: number, type: string): Promise<Valuable<number>> {
        return this.Restangular
                   .one('loan-items/size')
                   .get({user: userId, types: type});
    }
}
